import { render, staticRenderFns } from "./addInternal.vue?vue&type=template&id=01db63c0&scoped=true"
import script from "./addInternal.vue?vue&type=script&lang=js"
export * from "./addInternal.vue?vue&type=script&lang=js"
import style0 from "./addInternal.vue?vue&type=style&index=0&id=01db63c0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01db63c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01db63c0')) {
      api.createRecord('01db63c0', component.options)
    } else {
      api.reload('01db63c0', component.options)
    }
    module.hot.accept("./addInternal.vue?vue&type=template&id=01db63c0&scoped=true", function () {
      api.rerender('01db63c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/logisticsSystem/InternalDelivery/addInternal/addInternal.vue"
export default component.exports